<template>
   <van-popup v-model:show="show" @click-overlay="() => playClickSound()" position="left" round @opened="resetScroll"
      ref="sidebarRef" :style="{ height: '100%', width: '70%', zIndex: '10002', padding: '0px 0px 48px' }">
      <van-row class="navBar" justify="space-between">
         <van-col span="5" @click="closeSidebar" class="header_item_menu">
            <van-icon name="wap-nav" color="#fff" size="45" :class="{ 'rotate-animation': isRotating }" />
         </van-col>
         <van-col span="18" class="header_item_logo">
            <img src="@/assets/themeThree/logo.png" alt="">
         </van-col>
      </van-row>
      <div class="groupList">
         <van-row class="game_list" v-for="(item) in props.listGameData" :key="item.id" @click="goToGamePannel(item)"
            align="center">
            <van-col span="8" class="game_img_col">
               <img class="game_icon" :src="item.customIcon" alt="" />
            </van-col>
            <van-col span="16" class="game_img_col">
               <div>{{ $t(item.showName) }}</div>
            </van-col>
         </van-row>
      </div>
      <div class="reportBtn" @click="goToGameLog">{{ $t('common.bettingRecords') }}</div>
      <div style="padding-right: 10px;">
         <van-row class="game_list" v-for="(item, index) in menuList" :key="index" @click="menuClick(item.name)"
            align="center">
            <van-col span="6" class="game_img_col">
               <img class="game_icon" :src="item.activity_icon" alt="" />
            </van-col>
            <van-col span="16" class="game_img_col">
               <div>{{ t(`activityName.${item.name}`) }}</div>
            </van-col>
         </van-row>
      </div>

      <van-row class="caller" @click="openContactPopup">
         <van-col span="18" style="border-left: 3px solid blue; padding-left: 15px;">
            <div>{{ $t('message.support') }}</div>
            <div><span>24/7</span></div>
         </van-col>
         <van-col span="6" style="display: flex; justify-content: right;">
            <img src="@/assets/themeThree/caller.png" alt="" width="55%" style="padding-right: 10px;">
         </van-col>
      </van-row>
   </van-popup>
   <!-- <PwaAntiBlockingPopup ref="pwaPopupRef" />
   <PwaStatusPopup ref="pwaPopupStatusRef" /> -->
</template>

<script setup lang="ts">
import { computed, inject, ref, } from 'vue'
import { useRouter } from 'vue-router'
import { playClickSound } from '@/utils/media'
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity'
import { useUserStore } from '@/stores/user'
import PwaAntiBlockingPopup from '../common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../common/pwaStatusPopup.vue'
import { handleMenuClick, SideMenuListItem } from '@/view/components/supportFunction'
const activityStore = useActivityStore()
const userStore = useUserStore()
const { t } = useI18n();
const show = ref(false)
const router = useRouter()
const menuList = computed<SideMenuListItem[]>(() => activityStore.activityList)
const isRotating = ref(false);
const collectPopupRef = ref()
const collectTimeDropPopupRef = ref()
const agentRef = ref()

const emits = defineEmits(['intallPWA', 'openContactPopup', 'goToGamePanelSlide', 'openPWA'])
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const goToGamePannel = (data: any) => {
   show.value = false
   emits('goToGamePanelSlide', data)
}
const openContactPopup = () => {
   emits('openContactPopup')
}
const openSidebar = () => {
   show.value = true
}
const sidebarRef = ref<any>(null);

const resetScroll = () => {
   if (sidebarRef.value?.$el) {
      sidebarRef.value.$el.scrollTop = 0;
   }
   const popupEl = document.querySelector('.van-popup--left');
   if (popupEl) {
      popupEl.scrollTop = 0;
   }
};
const closeSidebar = () => {
   if (isRotating.value) return;
   isRotating.value = true;

   setTimeout(() => {
      show.value = false;
   }, 200);

   setTimeout(() => {
      isRotating.value = false;
   }, 1000);
}
const goToGameLog = () => {
   router.push('/sd-gamelog')
}
const props = defineProps<{
   listGameData: Array<{
      name: string,
      showName: string,
      customIcon: string,
      id: number | string,
   }>
}>()

const menuClick = (name: any) => {
   if(name === 'pwa_reward'){
      emits('openPWA')    
   }
   handleMenuClick(name, router, agentRef, collectPopupRef, collectTimeDropPopupRef,
      pwaPopupRef, pwaPopupStatusRef, show, canRecievedRewards.value, isOpen.value, t
   )
}


defineExpose({
   openSidebar,
   closeSidebar
})

</script>
<style scoped>
.navBar {
   width: 100%;
   z-index: 2000;
   padding: 15px 10px 5px;
   background: #0a1020;
   position: sticky;
   top: 0;
}

.header_item_menu {
   display: flex;
   align-items: center;
   justify-content: left;
}

.header_item_logo img {
   width: 90%;
}

.navBar_menu {
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 0 8px;
}

.navBar_menu img {
   width: 50px;
}

.navBar_logo {
   display: flex;
   align-items: center;
   justify-content: right;
   padding: 5px 0;
}

.navBar_logo img {
   width: 120px;
}

.navNotice img {
   width: 100%;
}

.van-popup {
   background: rgba(20, 27, 36, 0.8);
   -ms-overflow-style: none;
   scrollbar-width: none;
   overflow-y: auto;
   padding: 0 15px;
}

.van-popup::-webkit-scrollbar {
   display: none;
}

.infoContainer {
   background: #312734;
   border-radius: 10px;
   margin-top: 10px;
   padding: 10px;
}

.button_group {
   display: flex;
   justify-content: center;
   padding: 5px 0 0;
}

.btn_grid {
   padding: 4px;
}

.van-overlay {
   backdrop-filter: blur(5px);
   -webkit-backdrop-filter: blur(5px);
   z-index: 10001 !important;
}

.reportBtn {
   background: #1c2432;
   border-radius: 10px;
   font-size: 16px;
   padding: 20px 15px;
   color: #fff;
   text-align: center;
   margin: 15px;
}

.menu_list {
   padding: 12px 0;
   position: relative;
}

.menu_row {
   padding: 0 5%;
}

.menu_icon {
   width: 100%;
   margin-bottom: 10px;
}

.menu_grid_item {
   color: rgba(255, 255, 255, 0.45);
   box-sizing: border-box;
   border-radius: 10px;
}

.menu_item_inner {
   background-image: linear-gradient(180deg, rgb(129 54 94 / 12%) 0%, rgb(249 65 201 / 36%) 100%);
   border: 1.5px solid #daa6cf66;
   margin: 5px;
   border-radius: 10px;
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: 5px;
}

.menu_item_icon {
   width: 70%;
   object-fit: contain;
   padding: 10px;
   border-radius: 5px;
}

.menu_item_text {
   font-size: 12px;
   text-align: center;
   color: #ffffff;
}

.groupList {
   background-color: rgba(0, 0, 0, .28);
   padding: 5%;
   height: 40%;
   overflow: hidden;
   overflow-y: scroll;
   scrollbar-width: none;
   margin: 15px;
}

.game_list {
   color: #fff;
   border-radius: 10px;
   margin: 5px 20px;
   padding: 10px;
   font-size: 16px;
   position: relative;
   cursor: pointer;
}

.caller {
   background: linear-gradient(90deg, #11316e, #1c2432 40%, #1c2432);
   border-radius: 10px;
   color: #fff;
   font-size: 15px;
   padding: 10px 0;
   margin: 15px;
}

.caller span {
   color: #7d7d7d;
   font-size: 13px;
}

.game_img_col {
   display: flex;
   justify-content: left;
   align-items: center;
}

.game_icon {
   width: 40%;
   /* height: 25px; */
}

.game_name_col {
   display: flex;
   align-items: center;
   justify-content: center;
   text-align: center;
   height: 100%;
   flex-direction: column;
}


.game_name {
   font-size: 15px;
   color: #fff;
   margin-left: 10px;
}


.menu_img img {
   width: 25px;
}

.menu_text {
   color: #FFFFFF;
   font-size: 15px;
   font-weight: 400;
}

.menus {
   padding: 7.5px 0;
   position: relative;
}

.menu_icon_img {
   position: absolute;
   bottom: 0;
   right: 0;
   width: 82px;
   height: auto;
}

.share_content {
   border: 1px solid rgba(255, 255, 255, 0.3);
   border-radius: 10px;
   margin: 25px;
   padding: 5px 10px;
   display: flex;
   justify-content: center;
}

.share_item {
   border-radius: 30px;
   background: #7d7d7d12;
   width: 36px;
   height: 36px;
   margin: 5px;
}

.share_item img {
   width: 40px;
}

.user_info {
   color: rgba(255, 255, 255, 0.45);
}

.user_avatar img {
   width: 100%;
   border-radius: 10px;
}

.user_account {
   color: #fff;
   font-size: 4.2vw;
   padding-top: 5px;
   padding-left: 5px;
}

.user_ID {
   color: #fff;
   padding-top: 5px;
   padding-left: 5px;
   display: flex;
   align-items: end;
   font-size: 4.2vw;
}

.user_ID img {
   width: 20px;
   padding-left: 5px;
}

.rotate-animation {
   animation: rotateBack 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
   display: inline-block !important;
}

@keyframes rotateBack {
   0% {
      transform: rotate(0deg);
   }

   50% {
      transform: rotate(90deg);
   }

   100% {
      transform: rotate(0deg);
   }
}

:deep(.van-icon) {
   display: inline-block !important;
}

@media (min-width: 450px) {
   .user_avatar img {
      width: 45px;
   }

   .user_account {
      font-size: 15px;
   }

   .van-popup {
      width: 70% !important;
   }
}

@media (max-width: 450px) {
   .groupList {
      padding: 5px;
   }

   .game_list {
      margin: 10px;
      font-size: 13px;
   }

   .reportBtn {
      font-size: 13px;
   }
}

.btn_grid .btn_text {
   font-size: 1px !important;
}
</style>